<style lang="less" scoped>
.treeview-contain {
  /deep/ .v-treeview-node__root:hover {
    color: #1867c0 !important;
    caret-color: #1867c0 !important;
    background: #e7edf7;
  }
  .vuetify-disabled {
    color: #BDBDBD;
    text-decoration:line-through;  
  }

  .f-s {
      font-size: 10px;
      color: red;
  }
} 
</style>
<template>
  <div class="treeview-contain">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    />
    <v-treeview
      open-all
      :hoverable="true"
      :items="list"
      :loading-icon="'$loading'"
    >
      <template v-slot:label="{ item }">
        <!-- <span
          v-if="propsParams.showAc&&item.id!==0"
          :class="{
            'vuetify-disabled':item.del
          }"
        >{{ `（AC_${item.id}）${item.name}` }}</span> -->
        <span
          :class="{
            'vuetify-disabled':item.del
          }"
        >{{ item.full_name }} <span
          v-if="item.customer_function_id"
          style="font-size:12px;color:#757575"
        >【{{ customerFunction(item.customer_function_id) }}】</span></span>
      </template>
      <template v-slot:append="{ item }">
        <div>
          <v-btn
            v-if="!item.del"
            style="margin-left:10px"
            depressed
            x-small
            dark
            color="primary"
            @click="edit(item)"
          >
            编辑
          </v-btn>
        </div>
      </template>
    </v-treeview>
    <!-- <EditModal
      ref="edit"
      @success="getList"
    /> -->
    <EditTreeModal
      ref="edit"
      @success="getListProxy"
    />
  </div>
</template> 
<script>
  // import EditModal from './editModal'
  // import {getplacingAdsSkuQueryAllApi, postPlacingAdsSkuChangeApi} from '../service'
  import page_mixins from './page_mixins'
  import {getTreeListApi} from './service'
  import EditTreeModal from './EditTreeModal'
  import {mapGetters} from 'vuex'
  export default {
    components: {
      EditTreeModal,
    },
    mixins:[page_mixins],
    data() {
      return {
        list:[],
        loading: false
      }
    },
    computed: {
      ...mapGetters('async', [
        'customer_functions_hash',
      ]),
  
    },
    created() {
  
    },
    methods: {
      customerFunction(id) {
        if (!this.customer_functions_hash || !this.customer_functions_hash[id]) {
          return '-'
        }
        return this.customer_functions_hash[id].name
      },
      getListProxy() {
 
        this.loading = true
        getTreeListApi().then(res => {
          this.list = res
        }).finally(() => {
          this.loading = false
        })
      },
      getListFromParent() {

        if (this.list.length) {
          return 
        }
        this.getListProxy()
      },
      edit(item) {
        this.$refs.edit.edit(item)
      },


    }
  }
</script>
